"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HINT_TYPE = exports.ONBOARDING_STEPS = exports.PROFILE_COMPLETION = void 0;
var PROFILE_COMPLETION;
(function (PROFILE_COMPLETION) {
    PROFILE_COMPLETION["INFO"] = "info";
    PROFILE_COMPLETION["GROUPS"] = "groups";
})(PROFILE_COMPLETION = exports.PROFILE_COMPLETION || (exports.PROFILE_COMPLETION = {}));
var ONBOARDING_STEPS;
(function (ONBOARDING_STEPS) {
    ONBOARDING_STEPS["AVATAR"] = "avatar";
    ONBOARDING_STEPS["LOCATION"] = "location";
    ONBOARDING_STEPS["BIO"] = "bio";
    ONBOARDING_STEPS["DISCOVER_EVENTS"] = "discover_events";
    ONBOARDING_STEPS["DISCOVER_GROUPS"] = "discover_groups";
})(ONBOARDING_STEPS = exports.ONBOARDING_STEPS || (exports.ONBOARDING_STEPS = {}));
var HINT_TYPE;
(function (HINT_TYPE) {
    HINT_TYPE["BULK_SHARING"] = "bulk_sharing";
})(HINT_TYPE = exports.HINT_TYPE || (exports.HINT_TYPE = {}));
//# sourceMappingURL=User.js.map